import { RootState } from "store";

import { createSelector } from "@reduxjs/toolkit";

const selectDynamicFormPageLayout = (state: RootState) => state.dynamicForm;
const selectDynamicFormModalLayout = (state: RootState) => state.dynamicFormModal;

export const selectDynamicFormsByLayout = createSelector(
  selectDynamicFormPageLayout,
  selectDynamicFormModalLayout,
  (dynamicForm, dynamicFormModal) => {
    return {
      dynamicForm: dynamicForm,
      modalForm: dynamicFormModal,
    };
  }
);
